/* The contents of this file are generated automatically during the build process of this component.
 * If you need to make changes on these styles, go to the .scss files of this repository.
 * Once you are done, run the "npm run build" script to update this file and commit your changes, including this file.
*/

import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
/*CSS-START*/
:host {
  /* display none when modal is closed */
  display: none;
  /**
   * host is used as the modal backdrop
   * fit the backdrop across the viewport
   */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* tablet/desktop: allow consumer to change the width and height of the modal */
  --modal-min-width: 480px;
  --modal-max-width: var(--modal-small-max-width, 700px);
  --modal-body-min-height: var(--modal-small-body-min-height, 35px);
  --modal-body-max-height: 500px;
  --modal-close-icon-color: var(--modal-close-color, #169DBE);
  --color-outline: var(--modal-close-outline-color, #10B8E0);
  z-index: 99999;
}

:host([open]) {
  display: block;
}

:host [hidden] {
  display: none !important;
}

:host([size="small"]) {
  --modal-max-width: var(--modal-small-max-width, 700px);
}

:host([size="large"]) {
  --modal-max-width: var(--modal-large-max-width, 960px);
}

:host([size="x-large"]) {
  --modal-max-width: var(--modal-x-large-max-width, 1300px);
}

.screen-reader-text {
  border: 0;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  word-wrap: normal;
}

/* #wrapper-outer is needed because MS Edge is broken with position: fixed; & flexbox */
#wrapperOuter {
  @apply --layout;
  width: 100%;
  height: 100%;
  background: var(--modal-backdrop-background-color, none);
  overflow-y: var(--modal-wrapper-outer-overflow-y, initial);
}

/**
 * #wrapper is the modal visually -- has white background and border (tablet/desktop)
 */
#wrapper {
  position: relative;
  background: var(--modal-background-color, white);
  @apply --layout-vertical;
}

/**
 * #content has the dialog role, so this is what screen readers will see and read
 * includes accessibilty text, title and body
 */
#content {
  outline: none;
  @apply --layout-vertical;
  justify-content: var(--modal-content-justify-content, unset);
  /**
   * Fix needed for scrolling modals
   * Firefox Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1154269
   */
  min-height: 0;
}

#body {
  overflow-y: var(--modal-overflow-y, hidden);
  outline: none;
}

::slotted([slot=body]) {
  color: var(--modal-body-color);
  min-height: var(--modal-body-min-height);
  max-height: var(--modal-body-max-height);
  outline: unset !important;
}

#body::-webkit-scrollbar {
  width: 5px;
}

#body::-webkit-scrollbar-track {
  -webkit-border-radius-topright: 6px;
  border-top-right-radius: 6px;
}

#body::-webkit-scrollbar-thumb {
  background-color: var(--modal-scrollbar-color, var(--secondary-message));
  -webkit-border-radius: 1ex;
}

hr#buttonsSeparator {
  flex-grow: 0;
  flex-shrink: 0;
  margin: var(--modal-button-separator-margin, 30px 0);
  height: 1px;
  border: 0;
  border-top: 1px solid;
  border-top-color: var(--modal-button-separator-color, var(--secondary-message-detail));
}

hr.title-and-body-separator {
  margin: var(--modal-title-separator-margin, 15px -15px 20px -15px);
  height: 1px;
  border: 0;
  border-top: 1px solid;
  border-top-color: var(--modal-title-separator-color, var(--secondary-message-chrome));
}

#buttonsWrapper {
  @apply --layout;
  /* don't allow buttons wrapper to grow or shrink */
  -ms-flex: 0 0 auto;
  -webkit-flex: 0 0 auto;
  flex: 0 0 auto;
}

.close:hover,
.close:active {
  outline: none;
}

.close:focus {
  @apply --focus;
  outline: 2px solid var(--color-outline, #10B8E0);
}

::slotted([slot=title]) {
  color: var(--modal-header-color);
  margin: 0 !important;
}

@media only screen and (min-width: 768px) {
  /**
   *
   * Dialog Modal
   * For Tablet/Desktop
   *
   */
  #wrapperOuter.dialog {
    background: var(--modal-backdrop-background-color, rgba(255, 255, 255, 0.9));
    @apply --layout-center-justified;
    @apply --layout-center;
    overflow-y: scroll;
  }
  .dialog #wrapper {
    max-height: 100%;
    border: var(--modal-border-width, 2px) solid var(--modal-border-color, var(--secondary-message));
    border-radius: var(--modal-border-radius, 3px);
    box-sizing: border-box;
    margin: var(--modal-dialog-margin, 30px);
    padding: var(--modal-dialog-padding, 30px);
    min-width: var(--modal-min-width);
    -webkit-flex-basis: var(--modal-max-width);
    flex-basis: var(--modal-max-width);
  }
  .dialog #wrapper.no-padding {
    padding: 0;
  }
  .dialog #title {
    margin: var(--modal-header-margin, 0px 0px 35px 0px);
  }
  ::slotted([slot=title]) {
    @apply --font28;
    @apply --font-heavy;
    @apply --modal-title-font-size-mixin;
    @apply --modal-title-font-weight-mixin;
  }
  /* spacing between modal title and close icon */
  .dialog #title.has-spacing {
    margin-right: 50px;
  }
  .dialog #body {
    min-height: var(--modal-body-min-height);
    max-height: var(--modal-body-max-height);
  }
  /* scrollbar spacing */
  .dialog #body.has-scrollbar {
    padding-right: 45px;
    margin-right: 5px;
  }
  .dialog hr.title-and-body-separator {
    display: var(--modal-title-separator-standard-display, none);
  }
  .dialog hr#buttonsSeparator {
    display: var(--modal-button-separator-standard-display, block);
  }
  .dialog #buttonsWrapper {
    @apply --layout-horizontal-reverse;
    @apply --layout-end-justified;
  }
  .dialog #buttonsWrapper ::slotted(*) {
    margin-left: 30px;
    /* use smaller buttons for modal */
    flex-grow: 0;
    width: auto;
  }
  /* spacer to force buttons to be smaller in size */
  .dialog #buttons-spacer {
    flex-grow: 1;
  }
  #closeArrow {
    display: none;
  }
  #closeX {
    display: block;
  }
}

/* close icon shown on tablet/desktop */
#closeX {
  width: 24px;
  height: 24px;
  position: absolute;
  z-index: var(--modal-close-icon-z-index, auto);
  top: var(--modal-close-icon-top, 35px);
  right: var(--modal-close-icon-right, 25px);
  transform: scale(var(--modal-close-x-transform, 1));
  transition: var(--modal-close-icon-transition, none);
  cursor: pointer;
  overflow: hidden;
  color: var(--modal-close-icon-color, #169DBE);
}

#closeX:hover, #closeX:focus {
  color: var(--modal-x-hover-color, var(--secondary-hover, #0470AB));
}

#closeX:active {
  color: var(--modal-x-active-color, var(--primary-dark));
}

#closeX svg {
  width: 100%;
  height: 100%;
  stroke-width: var(--modal-close-icon-stroke-width, 4);
}

@media only screen and (max-width: 767.98px) {
  /**
   *
   * Fullscreen Modal
   * For Mobile (XS)
   *
   */
  /* Visually #wrapper is the modal -- has white background */
  .dialog #wrapper {
    width: 100%;
    @apply --layout-justified;
    padding: var(--modal-dialog-padding, 15px);
    margin: var(--modal-dialog-margin, 0);
    border-radius: var(--modal-dialog-border-radius, 3px);
  }
  .dialog #wrapper.no-padding {
    padding: 0;
  }
  /* scrollbar spacing */
  .dialog #body.has-scrollbar {
    padding-right: 25px;
    margin-right: -5px;
  }
  .dialog #title {
    text-align: center;
    padding: 0 20px;
  }
  ::slotted([slot=title]) {
    @apply --font20;
    @apply --font-heavy;
    @apply --modal-title-xs-font-size-mixin;
    @apply --modal-title-xs-font-weight-mixin;
  }
  .resize ::slotted([slot=title]) {
    padding: 0 20px;
    @apply --font18;
  }
  /**
   * Avoiding unitless flex-basis
   * https://philipwalton.com/articles/normalizing-cross-browser-flexbox-bugs/
   * Fix for IE11/Edge
   */
  .dialog #content {
    flex: 1 0 0%;
  }
  /* Note: HR extends full width  (negative margins) */
  .dialog hr.title-and-body-separator {
    display: var(--modal-title-separator-small-display, block);
  }
  .dialog hr#buttonsSeparator {
    display: var(--modal-button-separator-small-display, none);
  }
  .dialog #buttonsWrapper {
    @apply --layout-vertical;
  }
  .dialog #buttons-spacer {
    display: none;
  }
  .dialog #buttonsWrapper ::slotted(*) {
    margin-top: 15px;
    max-width: 100%;
  }
  #closeArrow {
    display: block;
  }
  #closeX {
    display: var(--modal-close-x-display, none);
  }
}

/**
 *
 * Fullscreen Modal
 * For Mobile (XS)
 *
 */
/* Visually #wrapper is the modal -- has white background */
.fullscreen #wrapper {
  width: 100%;
  @apply --layout-justified;
  padding: var(--fullscreen-modal-padding, 15px);
}

.fullscreen #body.has-scrollbar {
  /* scrollbar spacing */
  padding-right: var(--modal-fullscreen-has-scrollbar-padding-right, 25px);
  margin-right: var(--modal-fullscreen-has-scrollbar-margin-right, -5px);
}

.fullscreen #title {
  text-align: center;
  padding: var(--modal-fullscreen-title-padding, 0 20px);
}

.fullscreen ::slotted([slot=title]) {
  @apply --font20;
  @apply --font-heavy;
}

.fullscreen .resize ::slotted([slot=title]) {
  padding: 0 20px;
  @apply --font18;
}

.fullscreen #content {
  /**
    * Avoiding unitless flex-basis
    * https://philipwalton.com/articles/normalizing-cross-browser-flexbox-bugs/
    * Fix for IE11/Edge
    */
  flex: 1 0 0%;
}

.fullscreen hr.title-and-body-separator {
  /* Note: HR extends full width  (negative margins) */
  display: var(--modal-title-separator-small-display, block);
}

.fullscreen hr#buttonsSeparator {
  display: var(--modal-button-separator-small-display, none);
}

.fullscreen #buttonsWrapper {
  @apply --layout-vertical;
}

.fullscreen #buttons-spacer {
  display: none;
}

.fullscreen #buttonsWrapper ::slotted(*) {
  margin-top: 15px;
  max-width: 100%;
}

.fullscreen #closeArrow {
  display: block;
}

.fullscreen #closeX {
  display: var(--modal-fullscreen-close-x-display, none);
}

/**
 * Docker Modal
 */
@-webkit-keyframes slide-left {
  0% {
    transform: translateX(640px);
  }
  100% {
    transform: translateX(0px);
  }
}

@-moz-keyframes slide-left {
  0% {
    transform: translateX(640px);
  }
  100% {
    transform: translateX(0px);
  }
}

@-ms-keyframes slide-left {
  0% {
    transform: translateX(640px);
  }
  100% {
    transform: translateX(0px);
  }
}

@-o-keyframes slide-left {
  0% {
    transform: translateX(640px);
  }
  100% {
    transform: translateX(0px);
  }
}

@keyframes slide-left {
  0% {
    transform: translateX(640px);
  }
  100% {
    transform: translateX(0px);
  }
}

@-webkit-keyframes slide-right {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@-moz-keyframes slide-right {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@-ms-keyframes slide-right {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@-o-keyframes slide-right {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@keyframes slide-right {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@-webkit-keyframes slide-right {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@-moz-keyframes slide-right {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@-ms-keyframes slide-right {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@-o-keyframes slide-right {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@keyframes slide-right {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}

@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
    filter: alpha(opacity=0);
  }
  to {
    opacity: 1;
    filter: alpha(opacity=100);
  }
}

@-moz-keyframes fadeIn {
  from {
    opacity: 0;
    filter: alpha(opacity=0);
  }
  to {
    opacity: 1;
    filter: alpha(opacity=100);
  }
}

@-ms-keyframes fadeIn {
  from {
    opacity: 0;
    filter: alpha(opacity=0);
  }
  to {
    opacity: 1;
    filter: alpha(opacity=100);
  }
}

@-o-keyframes fadeIn {
  from {
    opacity: 0;
    filter: alpha(opacity=0);
  }
  to {
    opacity: 1;
    filter: alpha(opacity=100);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    filter: alpha(opacity=0);
  }
  to {
    opacity: 1;
    filter: alpha(opacity=100);
  }
}

@-webkit-keyframes fadeOut {
  from {
    opacity: 1;
    filter: alpha(opacity=100);
  }
  to {
    opacity: 0;
    filter: alpha(opacity=0);
  }
}

@-moz-keyframes fadeOut {
  from {
    opacity: 1;
    filter: alpha(opacity=100);
  }
  to {
    opacity: 0;
    filter: alpha(opacity=0);
  }
}

@-ms-keyframes fadeOut {
  from {
    opacity: 1;
    filter: alpha(opacity=100);
  }
  to {
    opacity: 0;
    filter: alpha(opacity=0);
  }
}

@-o-keyframes fadeOut {
  from {
    opacity: 1;
    filter: alpha(opacity=100);
  }
  to {
    opacity: 0;
    filter: alpha(opacity=0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    filter: alpha(opacity=100);
  }
  to {
    opacity: 0;
    filter: alpha(opacity=0);
  }
}

@media only screen and (min-width: 320px) and (max-width: 567px) {
  @-webkit-keyframes slide-left {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0%);
    }
  }
  @-moz-keyframes slide-left {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0%);
    }
  }
  @-ms-keyframes slide-left {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0%);
    }
  }
  @-o-keyframes slide-left {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0%);
    }
  }
  @keyframes slide-left {
    0% {
      transform: translateY(100%);
    }
    100% {
      transform: translateY(0%);
    }
  }
  @-webkit-keyframes slide-right {
    0% {
      transform: translateY(0%);
    }
    100% {
      transform: translateY(100%);
    }
  }
  @-moz-keyframes slide-right {
    0% {
      transform: translateY(0%);
    }
    100% {
      transform: translateY(100%);
    }
  }
  @-ms-keyframes slide-right {
    0% {
      transform: translateY(0%);
    }
    100% {
      transform: translateY(100%);
    }
  }
  @-o-keyframes slide-right {
    0% {
      transform: translateY(0%);
    }
    100% {
      transform: translateY(100%);
    }
  }
  @keyframes slide-right {
    0% {
      transform: translateY(0%);
    }
    100% {
      transform: translateY(100%);
    }
  }
}

.docker#wrapperOuter {
  background: var(--modal-backdrop-background-color, rgba(25, 148, 215, 0.3));
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row-reverse;
}

.docker#wrapperOuter.fadeIn {
  animation-name: fadeIn;
  animation-timing-function: cubic-bezier(0.3, 0.17, 0.16, 1);
  animation-duration: 0.4s;
}

.docker#wrapperOuter.fadeOut {
  animation-name: fadeOut;
  animation-timing-function: ease-in;
  animation-duration: 0.33s;
}

.docker#wrapperOuter #closeX svg {
  stroke-width: var(--modal-docker-close-icon-stroke-width, 2);
}

@media only screen and (min-width: 320px) and (max-width: 567px) {
  .docker#wrapperOuter.fadeOut, .docker#wrapperOuter.fadeIn {
    background: transparent;
  }
  .docker#wrapperOuter #closeX {
    left: var(--modal-docker-close-icon-mobile-left, 15px);
    top: var(--modal-docker-close-icon-mobile-top, 25px);
  }
  .docker#wrapperOuter #closeX svg {
    stroke-width: 2;
  }
}

.docker ::slotted([slot=body]) {
  max-height: 100vh;
  outline-color: transparent;
  outline-style: solid;
  outline-width: 0px;
}

.docker #wrapper {
  @apply --layout-vertical-reverse_-_flex-direction;
  @apply --layout-justified;
  width: 100%;
  padding: 0px;
}

@media only screen and (min-width: 640px) {
  .docker #wrapper {
    width: var(--docker-modal-desktop-width, 640px);
  }
}

.docker #body {
  overflow-y: var(--docker-modal-overflow-y, hidden);
}

.docker #body.has-scrollbar {
  /* scrollbar spacing */
  padding-right: var(--docker-modal-padding-right, 5px);
  margin-right: var(--docker-modal-margin-right, -5px);
  overflow-y: var(--docker-modal-overflow-y, hidden);
}

.docker #title {
  text-align: center;
  padding: 0 20px;
}

.docker ::slotted([slot=title]) {
  @apply --font20;
  @apply --font-heavy;
}

.docker .resize ::slotted([slot=title]) {
  padding: 0 20px;
  @apply --font18;
}

.docker .slide-right {
  animation: slide-right 0.3s ease-in-out both;
}

.docker .slide-left {
  animation: slide-left 0.4s ease-in both;
}

.docker .fadeOut {
  animation-name: fadeOut;
  animation-timing-function: ease-in-out;
  animation-duration: 0.33s;
}

.docker #content {
  /**
    * Avoiding unitless flex-basis
    * https://philipwalton.com/articles/normalizing-cross-browser-flexbox-bugs/
    * Fix for IE11/Edge
    */
  flex: 1 0 0%;
}

.docker hr .title-and-body-separator {
  /* Note: HR extends full width  (negative margins) */
  display: var(--modal-title-separator-small-display, block);
}

.docker hr #buttonsSeparator {
  display: var(--modal-button-separator-small-display, none);
}

.docker #buttonsWrapper {
  @apply --layout-vertical;
}

.docker #buttons-spacer {
  display: none;
}

.docker #buttonsWrapper ::slotted(*) {
  margin-top: 15px;
  max-width: 100%;
}

.docker #closeArrow {
  display: none;
}

.docker #closeX {
  display: block;
  color: var(--docker-modal-close-icon-color, var(--link-theme));
  top: var(--docker-modal-close-icon-top, 24px);
  right: var(--docker-modal-close-icon-right, 24px);
}

@media only screen and (min-width: 320px) and (max-width: 567px) {
  .docker #closeX.close {
    left: 15px;
    top: 20px;
  }
}

/* close arrow shown on mobile */
#closeArrow {
  position: absolute;
  top: 17px;
  left: 8px;
  @apply --user-select-none;
  @apply --font18;
  color: var(--modal-arrow-color, var(--primary));
  cursor: pointer;
}

#closeArrow .di {
  @apply --font18;
}

#closeArrow:hover, #closeArrow:focus {
  color: var(--modal-arrow-hover-color, var(--secondary-hover, #0470AB));
}

#closeArrow:active {
  color: var(--modal-arrow-active-color, var(--primary-dark));
}

@media print {
  * {
    overflow: visible !important;
  }
  header,
  footer {
    display: none;
  }
  :host {
    position: absolute;
    height: 100vh;
    overflow-y: visible;
    overflow-y: -moz-scrollbars-vertical;
    background: #FFF;
    background-color: #FFF;
    top: 0;
    opacity: 1;
  }
  .slide-top ::slotted([slot="title"]),
  .slide-top .slide-top .title {
    display: block;
    font-size: 32px;
    margin: auto;
    padding-top: 40px;
  }
  .docker #closeX {
    display: none;
  }
  .docker #wrapper {
    width: 100%;
    margin: 0;
    padding: 0;
    height: 100vh;
    background: #FFF;
  }
  .docker #body {
    overflow-y: visible !important;
  }
}
/*CSS-END*/
</style>
</template>`;

styleElement.register('dcl-modal-style');
